import { LinkProducer, NavigateFunction } from '@domain/app';
import { Card } from '@generated-types';

export const getCardDetailsUrl = (produceLink: LinkProducer) => (card: Card) => {
    return produceLink('CARD_PAGE')({ ctype: card.type, cid: card.id });
};

export const navigateToCardDetails = (navigate: NavigateFunction) => (card: Card) => {
    return navigate('CARD_PAGE')({ ctype: card.type, cid: card.id });
};

export const getCardControlUrl = (card: Card) => (produceLink: LinkProducer) =>
    produceLink('CARD_CONTROL_PAGE')({ ctype: card.type, cid: card.id });

export const getCardTransactionsUrl = (card: Card) => (linkProducer: LinkProducer) => {
    return linkProducer('CARD_TRANSACTION_PAGE')({ ctype: card.type, cid: card.id });
};

export const getCardDocumentsUrl = (card: Card) => (linkProducer: LinkProducer) => {
    return linkProducer('CARD_DOCUMENTS_PAGE')({ ctype: card.type, cid: card.id });
};

export const getCardRulesUrl = (card: Card) => (linkProducer: LinkProducer) => {
    return linkProducer('CARD_RULES_PAGE')({ ctype: card.type, cid: card.id });
};

export const getChangeCreditLimitUrl = (card: Card) => (linkProducer: LinkProducer) => {
    return linkProducer('CARD_CREDIT_LIMIT_PAGE')({ ctype: card.type, cid: card.id });
};
